'use client';

import { UserList } from '@/app/components/server/user-list';
import type { DatoCareerCoach, DatoModuleFormat } from '@/lib/datocms';

import type { FlexProps } from '@ironhack/design-system2/components';
import type { ReactElement } from 'react';

export type CoachList = {
  cards: DatoCareerCoach[];
  subtitle: string;
  title: string;
};

type Props = { data: CoachList } & FlexProps;

export const CoachList = (props: Props): ReactElement => {
  const {
    data: { cards = [], subtitle, title },
    ...flexProps
  } = props;

  const userListData = {
    cards,
    moduleFormat: [
      { background: 'light', spacingBottom: '40', spacingTop: '40' },
    ] as [DatoModuleFormat],
    subtitle,
    title,
  };

  return <UserList as="section" data={userListData} {...flexProps} />;
};
